import { parseScheduleText } from '../components/ScheduleEditor';
import { formatScheduleTimeDisplay, scheduleTimeToMinutes } from './scheduleTimeUtils';

/**
 * Published schedule items for calendar cells / week grid.
 * @param {string} raw published schedule JSON
 * @returns {Array<{ id: string, item: string, time: string, timeLabel: string, minutes: number|null, notes: string }>}
 */
export function getPublishedScheduleItems(raw) {
  const { lines } = parseScheduleText(String(raw || ''));
  return lines
    .filter((ln) => ln.kind === 'schedule')
    .map((ln) => {
      const time = String(ln.time || '').trim();
      const period = ln.period || 'AM';
      const item = String(ln.item || '').trim();
      const notes = String(ln.notes || '').trim();
      const timeLabel = formatScheduleTimeDisplay(time, period);
      return {
        id: ln.id,
        item,
        time,
        period,
        timeLabel,
        minutes: scheduleTimeToMinutes(time, period),
        notes,
      };
    })
    .filter((row) => row.item || row.timeLabel || row.notes);
}
